import React, { useState } from "react";
import BackOffice from "./navbar-parts/Backoffice";
import AdminMenu from "./navbar-parts/Admin";
import HomeLink from "./navbar-parts/HomeLink";
import UserMenu from "./navbar-parts/User";
import CollaudoMenu from "./navbar-parts/Collaudo";
import TicketsMenu from "./navbar-parts/Centrale"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft } from '@fortawesome/free-solid-svg-icons';

import { Collapse, Container, Navbar, NavbarToggler, Nav, NavItem, Button, NavLink } from "reactstrap";
import { useAuth0 } from "../auth/react-auth0-wrapper";

import HeaderUserbox from './layout-components/HeaderUserbox';
import clsx from 'clsx';
import { setSidebarToggleMobile } from './reducers/ThemeOptions';


const NavBar = ({ roots, id }) => {

  const { isAuthenticated } = useAuth0();
  const [sidebarToggleMobile, setSidebarToggleMobile] = useState(true);

  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile);
  };

  if (!isAuthenticated) return null;

  return (
    <div id={id} className="app-header app-header--shadow app-sidebar--light" >

      <div className="app-header--pane">
        <button
          className={clsx(
            'navbar-toggler hamburger hamburger--elastic toggle-mobile-sidebar-btn',
            { 'is-active': sidebarToggleMobile }
          )}
          onClick={toggleSidebarMobile}>
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </button>
        <Nav className="navbar-nav-scroll">
          <NavItem>
            <HomeLink roots={roots} />
          </NavItem>
        </Nav>
      </div>

      <div className="app-header--pane">
        <Container>
          <Nav className="navbar-nav-scroll" >
            <AdminMenu path={roots.ADMIN} />
            <BackOffice path={roots.BACKOFFICE} />
            <CollaudoMenu path={roots.COLLAUDO} />
            <TicketsMenu path={roots.CENTRALE} />
            <UserMenu />
          </Nav>
        </Container>
      </div>

    </div>
  );
};

export default NavBar;
